import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchProducts } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useWishlist } from "@/context/WishlistContext";
import { ext } from "@/lib/ext";
import ProductCard from "@/components/ProductCard";

const Wishlist = () => {
  const { lang } = useLang();
  const e = ext[lang];
  const { slugs } = useWishlist();
  const { data: products = [] } = useQuery({ queryKey: ["products"], queryFn: fetchProducts });
  const shown = products.filter((p) => slugs.includes(p.slug));

  return (
    <main data-testid="wishlist-page">
      <div className="border-b border-border px-4 py-6 sm:px-6">
        <h1 className="text-2xl uc font-semibold sm:text-3xl">{e.wishlist} [{shown.length}]</h1>
      </div>
      {shown.length === 0 ? (
        <div className="flex flex-col items-center gap-4 py-20">
          <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">{e.noWish}</p>
          <Link to="/" className="border border-border px-6 py-3 font-mono text-[11px] uppercase tracking-widest hover:bg-foreground hover:text-white">{lang === "ro" ? "VEZI PRODUSELE" : "BROWSE PRODUCTS"}</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {shown.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </main>
  );
};

export default Wishlist;
